/**
 * PullGameIncidentsQueryInfo defines properties and callbacks for the pull of gameIncidents endpoint of the sports data client.
 * @class SportDataGatewayQueryInfo
 */
export class PullGameIncidentsQueryInfo {
    /* istanbul ignore next */
    constructor(eventIds, onMessageHandler, onErrorHandler, incidentTypes, top, skip, format) {
        this.onMessageHandler = onMessageHandler;
        this.onErrorHandler = onErrorHandler;
        this.eventIds = eventIds;
        this.incidentTypes = incidentTypes;
        this.top = top;
        this.skip = skip;
        this.format = format;
    }
}
//# sourceMappingURL=PullGameIncidentsQueryInfo.js.map